import { TABLE_DATA_FAILURE_DISMISS, TABLE_DATA_SUCCESS_DISMISS } from '../../constants/types';

function dismissErrors(reduxIdentifier) {
  return {
    type: TABLE_DATA_FAILURE_DISMISS,
    reduxIdentifier,
  };
}

function dismissSuccess(reduxIdentifier) {
  return {
    type: TABLE_DATA_SUCCESS_DISMISS,
    reduxIdentifier,
  };
}

export { dismissErrors, dismissSuccess };
